module.exports = __webpack_public_path__ + "media/assets/icons/review_icon-6310b4c36094ec2def04282a71002f9f.svg";